.calendarWrapper {
	display: flex;
	flex-direction: column;
	background: #ffffff;
	border: 1px solid #e5e7eb;
	border-radius: 12px;
	overflow: hidden;
	margin: 0.4rem 0.7rem 1rem;
	position: relative;
}

.calendarToolbar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0.65rem 0.85rem;
	border-bottom: 1px solid #eef2f7;
	background: #f9fafb;
	gap: 0.65rem;
}

.toolbarLeft,
.toolbarRight {
	display: flex;
	align-items: center;
	gap: 0.4rem;
	min-width: 0;
}

.toolbarRight {
	justify-content: flex-end;
}

.totalChip {
	font-size: 0.72rem;
	font-weight: 600;
	color: #374151;
	background: #ecfdf5;
	border: 1px solid #a7f3d0;
	padding: 0.25rem 0.55rem;
	border-radius: 999px;
}

.navButton {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 2rem;
	height: 2rem;
	padding: 0;
	border-radius: 0.5rem;
	border: 1px solid #e5e7eb;
	background: #ffffff;
	color: #374151;
	cursor: pointer;
	transition:
		background 0.15s ease,
		border-color 0.15s ease;
}

.navButton:hover {
	background: #f3f4f6;
	border-color: #d1d5db;
}

.todayButton {
	padding: 0.35rem 0.85rem;
	height: 2rem;
	border-radius: 0.5rem;
	border: 1px solid #82bc44;
	background: #82bc44;
	color: #ffffff;
	font-size: 0.78rem;
	font-weight: 600;
	cursor: pointer;
	transition: background 0.15s ease;
}

.todayButton:hover {
	background: #6da337;
	border-color: #6da337;
}

.monthLabel {
	font-size: 1rem;
	font-weight: 700;
	color: #111827;
	flex: 1;
	text-align: center;
}

.weekHeader {
	display: grid;
	grid-template-columns: repeat(7, 1fr);
	background: #f3f4f6;
	border-bottom: 1px solid #e5e7eb;
}

.weekHeaderCell {
	padding: 0.5rem;
	font-size: 0.7rem;
	font-weight: 700;
	color: #6b7280;
	text-transform: uppercase;
	text-align: center;
	letter-spacing: 0.03em;
}

.daysGrid {
	display: grid;
	grid-template-columns: repeat(7, 1fr);
	grid-auto-rows: minmax(7.5rem, 1fr);
	background: #f3f4f6;
	gap: 1px;
}

.dayCell {
	background: #ffffff;
	display: flex;
	flex-direction: column;
	gap: 0.35rem;
	padding: 0.4rem 0.45rem;
	min-height: 7.5rem;
	overflow: hidden;
}

.dayCellOutside {
	background: #fafafa;
	color: #9ca3af;
}

.dayCellOutside .dayNumber {
	color: #9ca3af;
}

.dayCellToday {
	outline: 2px solid #82bc44;
	outline-offset: -2px;
}

.dayNumberRow {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.dayNumber {
	font-size: 0.78rem;
	font-weight: 700;
	color: #111827;
}

.dayCount {
	font-size: 0.62rem;
	font-weight: 700;
	color: #ffffff;
	background: #82bc44;
	padding: 0.05rem 0.4rem;
	border-radius: 999px;
	line-height: 1.4;
}

.dayEvents {
	display: flex;
	flex-direction: column;
	gap: 0.28rem;
	overflow: hidden;
	min-width: 0;
}

.eventButton {
	background: none;
	border: none;
	padding: 0;
	margin: 0;
	cursor: pointer;
	text-align: left;
	display: block;
	min-width: 0;
}

.moreEventsButton {
	background: #f3f4f6;
	border: 1px dashed #d1d5db;
	color: #4b5563;
	font-size: 0.65rem;
	font-weight: 600;
	padding: 0.18rem 0.4rem;
	border-radius: 0.4rem;
	cursor: pointer;
	transition:
		background 0.15s ease,
		color 0.15s ease;
	text-align: center;
}

.moreEventsButton:hover {
	background: #e5e7eb;
	color: #111827;
}

.emptyMessage {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.5rem;
	padding: 2rem 1rem;
	text-align: center;
	color: #6b7280;
	font-size: 0.9rem;
}

.dayDetailBackdrop {
	position: fixed;
	inset: 0;
	background: rgba(15, 23, 42, 0.45);
	display: grid;
	place-items: center;
	z-index: 1000;
	padding: 1rem;
}

.dayDetail {
	background: #ffffff;
	border-radius: 14px;
	width: 100%;
	max-width: 28rem;
	max-height: 80vh;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	cursor: default;
	box-shadow: 0 20px 50px rgba(15, 23, 42, 0.25);
	text-align: left;
}

.dayDetailHeader {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0.85rem 1rem;
	border-bottom: 1px solid #e5e7eb;
	background: #f9fafb;
}

.dayDetailTitle {
	font-size: 0.95rem;
	font-weight: 700;
	color: #111827;
	text-transform: capitalize;
}

.dayDetailClose {
	background: transparent;
	border: 1px solid #e5e7eb;
	border-radius: 0.5rem;
	color: #6b7280;
	width: 2rem;
	height: 2rem;
	display: grid;
	place-items: center;
	cursor: pointer;
}

.dayDetailClose:hover {
	background: #f3f4f6;
	color: #111827;
}

.dayDetailList {
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	padding: 0.85rem 1rem 1rem;
	overflow-y: auto;
}

@media (max-width: 768px) {
	.calendarWrapper {
		margin: 0.3rem 0.4rem 0.7rem;
	}
	.calendarToolbar {
		padding: 0.5rem 0.6rem;
		gap: 0.4rem;
	}
	.totalChip {
		display: none;
	}
	.daysGrid {
		grid-auto-rows: minmax(4.5rem, 1fr);
	}
	.dayCell {
		min-height: 4.5rem;
		padding: 0.25rem 0.3rem;
		gap: 0.2rem;
	}
	.dayNumber {
		font-size: 0.7rem;
	}
	.weekHeaderCell {
		font-size: 0.6rem;
		padding: 0.35rem 0.2rem;
	}
	.dayCount {
		font-size: 0.55rem;
		padding: 0.02rem 0.3rem;
	}
	.dayEvents {
		gap: 0.18rem;
	}
	.moreEventsButton {
		font-size: 0.58rem;
		padding: 0.1rem 0.3rem;
	}
	.monthLabel {
		font-size: 0.85rem;
	}
}
